<div class="row navigation-bar">
  <nav id="main-menu"
    class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top"
    role="navigation">
    <div class="container-fluid">
      <a class="navbar-brand" routerLink="/dashboard">
        <img src="../assets/img/mercatus-icon.svg" height="44" alt="Mercatus"/>
      </a>
      <button type="button"
        class="navbar-toggler"
        data-bs-toggle="collapse"
        data-bs-target="#navbar"
        aria-expanded="false"
        aria-controls="navbar"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div id="navbar" class="collapse navbar-collapse">
        <ul class="navbar-nav">
          @for (navItem of navItems; track navItem) {
            @if (!navItem.items) {
              <li class="nav-item" [class.active]="navItem.active">
                <a class="nav-link {{navItem.title}}" routerLink="{{navItem.link}}">
                  <img [src]="navItem.icon" class="mainnavicon" height="32" alt="navItem.title"/>
                  <span class="hideOnResize">{{navItem.title}}</span>
                </a>
              </li>
            } @else {
              <li class="nav-item dropdown" [class.active]="navItem.active">
                <a routerLink="{{navItem.link}}" class="nav-link dropdown-toggle" role="button" aria-haspopup="true" aria-expanded="false">
                  <img [src]="navItem.icon" class="mainnavicon" height="32" alt="navItem.title"/>
                  <span class="hideOnResize">{{navItem.title}}</span>
                </a>
                <ul class="dropdown-menu">
                  @for (subItem of navItem.items; track subItem) {
                    <li [class.active]="subItem.active" class="{{subItem.itemClass}}">
                      <a class="dropdown-item" routerLink="{{subItem.link}}">
                        @if (subItem.iconClass) {
                          <i class="{{subItem.iconClass}} me-2"></i>
                        }
                        {{subItem.title}}
                      </a>
                    </li>
                  }
                </ul>
              </li>
            }
          }
        </ul>
        <ul class="navbar-nav ms-auto">
          @let user = user$ | async;
          <li class="nav-item d-none d-sm-flex">
            <span class="nav-link">
              <img (click)="userNameClick$.next(true)" src="../assets/img/topnav/mercatus-user.svg" class="mainnavicon" height="32" alt="Logged in User: {{user?.email}}"/>
              <span class="hideOnResize">{{user?.email}}</span>
            </span>
          </li>
          <li class="nav-item">
            <a (click)="logout()" class="nav-link logout-element" title="{{user?.email}} abmelden">
              <img src="../assets/img/topnav/mercatus-logout.svg" class="mainnavicon" height="32" alt="Log Out"/>
              <span class="d-sm-none">Logout</span>
            </a>
          </li>
          <li class="nav-item">
            <a href="https://docs.mercatus.one" target="_blank" title="Hilfe" class="nav-link">
              <img src="../assets/img/topnav/mercatus-help.svg" class="mainnavicon" height="32" alt="Hilfe"/>
              <span class="d-sm-none">Hilfe</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
